// Helper function to create URL-friendly slugs for meal names
export function createMealSlug(mealName, mealId) {
    return mealName
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/-+/g, '-') // Replace multiple hyphens with single
        .replace(/^-+|-+$/g, '') // Remove leading/trailing hyphens
        + '-' + mealId; // Add meal ID for uniqueness
}

// Helper function to extract meal ID from slug
export function extractMealIdFromSlug(slug) {
    const parts = slug.split('-');
    return parts[parts.length - 1]; // Last part is the meal ID
}

// Helper function to generate meal URL
export function generateMealUrl(mealName, mealId) {
    return `/meal/${createMealSlug(mealName, mealId)}`;
}
